<template>
  <div id="sideNav" v-if="authenticated && !isTOSPage && isSomeMenuItemVisible">
    <div id="sideNavWrapper" class="border-r border-[#DCDFE5]">
      <el-menu class="side-nav-menu" :default-active="activeMenuItem?.id">
        <template v-for="menuItem in menuItems" :key="menuItem.id">
          <el-menu-item v-if="menuItem.isVisible" :index="menuItem.id" @click="onMenuItemClick(menuItem.id, menuItem.routeName, menuItem.fullPath)">
            <i :class="[`side-nav-${menuItem.id}`, menuItem.addClass]"></i>
            <p class="side-nav-menu-item-name truncate" :aria-label="menuItem.name">{{ menuItem.name }}</p>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div id="subSideNavWrapper" v-if="isSubMenuOpen && activeMenuItem">
      <el-menu class="side-nav-sub-menu" :default-active="activeSubMenuItem?.id">
        <template v-for="subMenuItem in subMenuItems" :key="subMenuItem.id">
          <el-menu-item v-if="subMenuItem.isVisible" :index="subMenuItem.id" @click="onSubMenuItemClick(subMenuItem.id)">
            <p :class="['side-nav-sub-menu-item-name', subMenuItem.name]">{{ subMenuItem.name }}</p>
          </el-menu-item>
        </template>
      </el-menu>
      <div class="side-menu-close-button" @click="onSubMenuNavClose"><i class="close-icon"></i></div>
    </div>
  </div>
</template>

<script src="./side-navigation.js"></script>
<style lang="scss" src="./side-navigation.scss"></style>
